const Config = {
  KEY: '',
  BASE_URL: 'https://rs-bed-covid-api.vercel.app/api/',
};

export default Config;
